import React from 'react';

// This component renders input fields as basic text inputs.
// Basic process: 
//  1) user types value into the input field
//  2) onChange handler gets called when user types in value into input field and value is saved in the parent
//  3) when component renders, its "value" is set to the value gets passed and  was saved in the parent
//  4) When user hits onSubmit, the parent's onSubmit function is called. The parent handles on the submit logic
//     and it clears the its input fields and passes new values to InputFields component via props.
//
// Props Required:
//  placeholder1: is placeholder text for input 1
//  placeholder2: is placeholder text for input 2
//  inputValue1:  is value of input field 1
//  inputValue2:  is value of input field 2
//  onChangeInput1:  function prop passed from parent that is called when input 1 changes
//  onChangeInput2:  function prop passed from parent that is called when input 2 changes
//  parentOnsubmit:  function prop passed from parent that is called when user submits form
//
// Note that the onsubmit button is an custom + icon. The icon can be replaced
// with text, another icon, or button of choice.
export const PicListInputFields = (props) => {

    // This calls the parents onSubmit function, Which will handles logic for input fields
    function onSubmit (e) {
        e.preventDefault();
        props.parentOnSubmit(e);
    }

    // This calls the parents onChange handler for input field 1
    function onChangeInput1 (e) {
        let item  = e.target.value;
        props.onChangeValue1(item);
    }

    // This calls the parents onChange handler for input field 2
    function onChangeInput2 (e) {
        let qty  = e.target.value;
        props.onChangeValue2(qty);
    }

    // ****************************************************************** */
    // Render Method
    // ****************************************************************** */
    return (
        <form className="pic-lists-inputfields-form" onSubmit={onSubmit} >
            <input  className="pic-lists-inputfields__input-1"
                type="text"
                placeholder={props.placeholder1}
                onChange={onChangeInput1}  // Handler called to update the state with whats entered in input field
                value={props.inputValue1}         // value to render component with (from value of state updated onChangeHandler
                maxLength="85"
            />
            <input  className="pic-lists-inputfields__input-2"
                type="number"
                placeholder={props.placeholder2}
                onChange={onChangeInput2}  // Handler called to update the state with whats entered in input field
                value={props.inputValue2}         // value to render component with (from value of state updated onChangeHandler
                min={1}
            />
            <button  className="tiny-plus-button">
                <div className="tiny-plus-icon-for-piclist">+</div>
            </button>
        </form>
    )
}

export default PicListInputFields;




// WEBPACK FOOTER //
// ./src/components/PicListsInputFields.js